export default "__VITE_ASSET__DaxCsIBo__"